/**
 * Drawer localization schema.
 * Defines all translation strings for the navigation drawer sections and items.
 *
 * @drawer_header @app_name Display name of the application in the drawer header.
 * @drawer_sections @section @title Section title displayed in the drawer (optional in rail mode).
 * @drawer_sections @section @drawer_items @title title Drawer item visible title.
 * @drawer_sections @section @drawer_items @tooltip_text Drawer item tooltip shown on hover.
 */
export default {
  // Drawer Header
  drawer_header: {
    app_name: "Lab Portal",
  },

  // Drawer Sections
  drawer_sections: {
    // Overview Section
    overview_section: {
      // Section Title
      title: "Общ преглед",

      // Overview Items
      drawer_items: {
        channels: {
          title: "Канали",
          tooltip_text: "Статус и управление на канали",
        },

        validation: {
          title: "Валидация",
          tooltip_text: "Валидация на резултати",
        },

        allVisits: {
          title: "Всички визити",
          tooltip_text: "Преглед на всички визити на пациенти",
        },

        newResults: {
          title: "Нови резултати",
          tooltip_text: "Наскоро получени резултати",
        },

        search: {
          title: "Търсене",
          tooltip_text: "Търсене на пациенти и проби",
        },

        starred: {
          title: "Отбелязани",
          tooltip_text: "Отбелязани елементи",
        },

        results: {
          title: "Резултати",
          tooltip_text: "Лабораторни резултати",
        },

        balance: {
          title: "Баланс",
          tooltip_text: "Баланс на плащания",
        },
      },
    },

    // About Section
    about_section: {
      // About Items
      drawer_items: {
        about: {
          title: "Относно",
          tooltip_text: "Информация за приложението",
        },
      },
    },

    // Dev Section (only visible when LAB_PORTAL_FE_DEV=true)
    dev_section: {
      title: "Разработчик",
      drawer_items: {
        uiStates: {
          title: "UI състояния",
          tooltip_text: "Каталог на UI състояния",
        },
      },
    },
  },
};
